import { useEffect } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, Controller } from 'react-hook-form'

import schema from '../../../../../../validators/assetSchema'
import { Button } from '../../../../../../components/Button'
import { Input } from '../../../../../../components/FormElements/Input'
import { type AssetPersistence } from '../../../../../../types/persistence/asset-persistence'

type AssetFormProps = {
  isSubmitting: boolean
  defaultValues?: AssetPersistence
  onSubmit: (data: AssetPersistence) => void
}

export const AssetForm = ({ isSubmitting, defaultValues, onSubmit }: AssetFormProps) => {
  const { control, formState, reset, handleSubmit } = useForm<AssetPersistence>(
    {
      defaultValues,
      resolver: yupResolver(schema),
      mode: 'onChange',
    }
  )

  useEffect(() => {
    return () => {
      reset()
    }
  }, [reset])

  return (
    <form
      className="p-6 max-h-[80vh] overflow-y-auto scrollbar"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="mb-14">
        <div className="mb-8">
          <Controller
            name="fullName"
            control={control}
            render={({
              field: { value = '', onChange },
              fieldState: { invalid, error },
            }) => (
              <Input
                label="Nome completo"
                autoFocus
                placeholder="Nome completo"
                isValid={!invalid && !!error}
                value={value}
                onChange={onChange}
                errorMessage={error?.message}
              />
            )}
          />
        </div>
      </div>

      <Button
        type="submit"
        disabled={!formState.isValid}
        isLoading={isSubmitting}
        fullWidth
      >
        {defaultValues ? 'Salvar' : 'Cadastrar'}
      </Button>
    </form>
  )
}
